import React from "react";
import { Link } from "react-router-dom";
import {
  formatNumber,
  renderBuyText,
} from "../../../middleware/common-functions";
import { ReaderItem } from "../../../models/reader";
import { UserItem } from "../../../models/user";
import { RatingStars } from "../../common/icons";

type BookInfoProps = {
  reader: ReaderItem;
  goBack: any;
  playVideo?: any;
  user: UserItem;
};

const BookInfo: React.FC<BookInfoProps> = ({
  reader,
  goBack,
  user,
  playVideo,
}) => (
  <div className="book_info" id="book_info">
    <div className="row">
      <div className="col-lg-4">
        <div className="book_cover">
          <img
            src={reader.images?.thumb}
            className="book_cover_xs"
            alt="Reader Cover"
          />
        </div>
      </div>
      <div className="col-lg-8 book_data">
        <div className="d-flex justify-content-between">
          <button className="btn back_btn" onClick={goBack}>
            <i className="fa fa-angle-left" aria-hidden="true"></i> Back
          </button>
          <div className="d-flex">
            {user.is_teacher ? (
              <div className="rating_group">
                <RatingStars
                  gold={false}
                  id="teacher_rating"
                  value={reader.rating_teachers}
                />
                Teachers' Rating{" "}
              </div>
            ) : null}
            {user.is_teacher ? (
              <div className="rating_group teachers">
                <RatingStars
                  gold={false}
                  id="students_rating"
                  value={reader.rating_students}
                />
                My Students'{" "}
              </div>
            ) : null}
            <div className="rating_group teachers">
              <RatingStars
                gold={false}
                id="students_rating"
                value={reader.rating}
              />
              Global
            </div>
          </div>
        </div>
        <div>
          <h1>{reader.title}</h1>
          <div className="badges_cont">
            {" "}
            <span className="badge badge-dark">{reader.level.name}</span>
            <span className="badge badge-dark">
              {reader.chapters} {reader.chapters === 1 ? "Chapter" : "Chapters"}{" "}
            </span>
            {user.is_teacher &&
            reader.chapter_questions &&
            reader.chapter_questions > 1 ? (
              <span className="badge badge-dark">
                {reader.chapter_questions} Quiz Questions
              </span>
            ) : null}
            <span className="badge badge-dark">{reader.language.name}</span>
            {reader.unique_words ? (
              <span className="badge badge-dark">
                Unique Words: {reader.unique_words}
              </span>
            ) : null}
            {reader.total_words ? (
              <span className="badge badge-dark">
                Total Words: {formatNumber(reader.total_words)}
              </span>
            ) : null}
            {reader.tense ? (
              <span className="badge badge-dark ">
                Tense(s):{" "}
                <span className="text-capitalize">{reader.tense}</span>
              </span>
            ) : null}
          </div>

          <div
            className="book_desc_info custom_scrollbar mt-1"
            dangerouslySetInnerHTML={{ __html: reader.description_short }}
          ></div>
        </div>
        <div className={`book_ctas ${reader.coming_soon ? "d-none" : null}`}>
          <Link
            to={`/reader/${reader.url}/${reader.id}${
              reader.user_chapter
                ? `/${reader.user_chapter}`
                : reader.has_prereading
                ? "/pre-reading"
                : ""
            }`}
            className="btn btn-danger green_contain_green"
          >
            <b>
              <span>
                {reader.user_chapter ? (
                  <i className="mr-2 fas fa-bookmark" aria-hidden="true"></i>
                ) : (
                  <i className="mr-2 fas fa-book" aria-hidden="true"></i>
                )}
              </span>{" "}
              {reader.user_chapter ? "Continue " : "Start "}
              <span className="xs_hidden">Reading</span>
            </b>
          </Link>
          {reader.user_chapter ? (
            <Link
              to={`/reader/${reader.url}/${reader.id}${
                reader.has_prereading ? "/pre-reading" : ""
              }`}
              className="btn text-light green_contain_gray"
            >
              <i className="fa mr-2 fa-reply" aria-hidden="true"></i>{" "}
              <span className="xs_hidden">Start from</span> the Beginning
            </Link>
          ) : null}
          <Link
            to={`/rate/${reader.url}/${reader.id}`}
            className="btn text-light rate_link green_contain_gray"
          >
            <i className="fa fa-star mr-2" aria-hidden="true"></i> Rate This
            Book
          </Link>
          {reader.vocab_url ? (
            <a
              href={`${process.env.REACT_APP_SITE_URL}${reader.vocab_url}`}
              download="true"
              target="_blank"
              rel="noreferrer"
              className="btn btn-primary green_contain_green_light"
            >
              <i className="fal fa-file-signature" aria-hidden="true"></i> Words
              to Know (download)
            </a>
          ) : null}
          {user.is_teacher && reader.print_url ? (
            <a
              target="_blank"
              href={reader.print_url}
              rel="noreferrer"
              className="btn btn-success green_contain_green_light"
            >
              <i className="fal fa-shopping-cart" aria-hidden="true"></i>{" "}
              {renderBuyText(reader.categories)}
            </a>
          ) : null}
        </div>
        {reader.video_url ? (
          <button className="btn video_btn" onClick={playVideo}>
            <i className="fa-3x fas fa-play" aria-hidden="true"></i> <br />
            Play Video Trailer
          </button>
        ) : null}
      </div>
    </div>
  </div>
);
export default BookInfo;
